let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jPath")).then(() => parcelRequire('8ZNcY'));